<template lang="html">
  <div class="content">
    <div class="ai-tabs tabs">
      <div class="actions__left-tilte">
        <b>数据列表</b>
      </div>
      <div class="ai-input-group actions__right">
        <input type="text"
               @keyup.enter="clickSearch"
               v-model="serchInput"
               class="ai-input ai-input-group__input actions__search-input"
               placeholder="请输入搜索内容"
        >
        <div class="ai-button ai-input-group__button actions__search-btn">
          <i class="material-icons"
             @click="clickSearch"
          >search</i>
        </div>
        <div class="ai-button ai-button--primary new-sub-account actions__add-btn"
             @click="createAR"
        >
          新建数据
        </div>
        <!-- <div class="ai-button ai-button--primary new-sub-account actions__add-btn"
             @click="creatNewAR">
          新建数据
        </div> -->
      </div>
    </div>
    <div class="table-wrapper">
      <table class="table">
        <thead>
          <tr>
            <th>场名称</th>
            <th>AR ID</th>
            <th>VR ID</th>
            <th>状态</th>
            <th>阶段</th>
            <th>更新时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in subaccounts" :key="index">
            <td style="width:10%">
              {{ item.name }}
            </td>
            <td style="width:20%">
              {{ item.ar_id }}
            </td>
            <td style="width:15%">
              {{ item.vr_id }}
            </td>
            <td style="width:5%">
              {{ item.status_verbose }}
            </td>
            <td style="width:10%">
              {{ item.stage_verbose }}
            </td>
            <td style="width:10%">
              {{ item.updated | timeFormatter }}
            </td>
            <td style="width:30%">
              <div class="ai-button ai-button--text ai-button--text--primary"
                   style="margin-right:10px;"
                   @click="BindVR(item)"
              >
                {{ ActivityText(item) }}
              </div>
              <!-- <div class="ai-button ai-button--text ai-button--text--primary"
                   style="margin-right:10px;"
                   @click="reDo(item)">
                重跑
              </div> -->
              <div class="ai-button ai-button--text ai-button--text--primary"
                   style="margin-right:10px;"
                   @click="editItemInfo(item)"
              >
                修改
              </div>
              <div class="ai-button ai-button--text ai-button--text--danger"
                   style="margin-right:10px;"
                   @click="showConfirm(item)"
              >
                删除
              </div>
              <div class="ai-button ai-button--text ai-button--text--primary"
                   style="margin-right:10px;"
                   @click="showDetail(item)"
              >
                详情
              </div>
              <!-- <div class="ai-button ai-button--text ai-button--text--primary"
                   style="margin-right:10px;"
                   @click="showYuyi(item)"
              >
                上传语意
              </div> -->
              <div class="ai-button ai-button--text ai-button--text--primary"
                   style="margin-right:10px;"
                   @click="showTest(item)"
              >
                测试视频
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <AiPagination v-model="currentPage"
                  class="pagination"
                  :total-page-count="totalPageCount"
                  @change="getData"
    />
    <AiDialog class="create-sub-dialog"
              width="80%"
              :visible.sync="createSubDialogVisible"
              @close="clearDialogInputs"
    >
      <div slot="header" class="create-sub-dialog__header">
        上传AR视频
      </div>
      <div v-show="(allUploaded>=6)" class="create-sub-dialog__content">
        <div style="margin-top: 10%;">
          <div style="margin: 20%;">
            <img src="@/assets/views/models/unselected.png">
          </div>
          所有上传视频完成！
        </div>
      </div>
      <div v-show="(allUploaded<6)" class="create-sub-dialog__content">
        <el-row :gutter="60">
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <div class="videoname">
                <b>视频1</b>
              </div>
              <div>
                <AiVideoUpload
                  :item-data="currentEditItem"
                  :item-num="0"
                  @finishUpload="onFinishUpload"
                />
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple-light">
              <div class="videoname">
                <b>视频2</b>
              </div>
              <div>
                <AiVideoUpload
                  :item-data="currentEditItem"
                  :item-num="1"
                  @finishUpload="onFinishUpload"
                />
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple-light">
              <div class="videoname">
                <b>视频3</b>
              </div>
              <div>
                <AiVideoUpload
                  :item-data="currentEditItem"
                  :item-num="2"
                  @finishUpload="onFinishUpload"
                />
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="60" style="margin-top:40px">
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <div class="videoname">
                <b>视频4</b>
              </div>
              <div>
                <AiVideoUpload
                  :item-data="currentEditItem"
                  :item-num="3"
                  @finishUpload="onFinishUpload"
                />
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple-light">
              <div class="videoname">
                <b>视频5</b>
              </div>
              <div>
                <AiVideoUpload
                  :item-data="currentEditItem"
                  :item-num="4"
                  @finishUpload="onFinishUpload"
                />
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple-light">
              <div class="videoname">
                <b>视频6</b>
              </div>
              <div>
                <AiVideoUpload
                  :item-data="currentEditItem"
                  :item-num="5"
                  @finishUpload="onFinishUpload"
                />
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="create-sub-dialog__footer" />
    </AiDialog>
    <AiDialog class="progress-dialog"
              width="441"
              :visible.sync="creatARUIVisible"
              @close="closeBindingDialog"
    >
      <div slot="header" class="progress-dialog__header">
        绑定VR ID
      </div>

      <div class="create-sub-dialog__creatARcontent">
        <div style="padding:20px">
          <b>VR ID</b>
          <el-input
            v-model="VRIDinput"
            placeholder="请输入VR ID"
            style="margin-top:20px;"
            @change="onInput"
            @keyup.enter.native="onInput"
          />
          <b>FLOOR</b>
          <el-input
            v-model="Floorinput"
            placeholder="请输入Floor"
            style="margin-top:20px;"
          />
        </div>
        <div style="padding:20px">
          <b>场名称:</b>
          <div style="margin-top:20px;font-size:14px">
            <font v-show="!getvrname" style="color:#888">
              {{ bindTip }}
            </font>
            <font v-show="getvrname" />
          </div>
        </div>
      </div>
      <div slot="footer" class="create-sub-dialog__footer">
        <div class="ai-button ai-button--primary"
             @click="bindVRID"
        >
          确 定
        </div>
        <div class="ai-button" @click="closeDialog">
          取 消
        </div>
      </div>
    </AiDialog>
    <!-- vr新增 -->
    <AiDialog class="progress-dialog"
              width="441"
              @close="creatVRUIVisible=false"
              :visible.sync="creatVRUIVisible"
    >
      <div slot="header" class="progress-dialog__header">
        绑定VR ID
      </div>

      <div>
        <div v-if="editInfo" class="progress-dialog__header">
        {{ar_name}}
        </div>
        <div style="padding:20px">
          <b>VR ID</b>
          <el-input
            :disabled="editInfo"
            v-model="newVRID"
            placeholder="请输入VR ID"
            style="margin-top:20px;"
          />
        </div>
      </div>
      <div>
        <div style="padding:20px">
          <b>group</b>
          <el-input
            v-model="group"
            placeholder="例:K11_GZ"
            style="margin-top:20px;"
          />
        </div>
      </div>
      <div>
        <div style="padding:20px">
          <b>floor</b>
          <el-input
            v-model="floor"
            placeholder="例:L1"
            style="margin-top:20px;"
          />
        </div>
      </div>
      <div v-if="!editInfo">
        <div style="padding:20px">
          <b>process_node</b>
          <el-input
            v-model="process_node"
            placeholder="例:rebot-k8s-gpu03"
            style="margin-top:20px;"
          />
        </div>
      </div>
      <div slot="footer" class="create-sub-dialog__footer">
        <div v-if="!editInfo" class="ai-button ai-button--primary"
             @click="addVrId"
        >
          确 定
        </div>

        <div v-else class="ai-button ai-button--primary"
             @click="toedit"
        >
          确 定
        </div>
        <div class="ai-button" @click="creatVRUIVisible=false">
          取 消
        </div>
      </div>
    </AiDialog>

    <AiDialog class="progress-dialog"
              width="60%"
              height="80%"
              :visible.sync="detailVisible"
              @close="closedetailDialog"
    >
      <div slot="header" class="progress-dialog__header">
        详情
      </div>

      <div class="create-sub-dialog__creatARcontent">
        <div>
          <div class="detailtxt">
            {{'raw_data_url: '+ detailInfo.raw_data_url}}
          </div>
          <div class="detailtxt">
            {{'pivideo_url: '+ detailInfo.pivideo_url}}
          </div>
          <div class="detailtxt">
            {{'pano_image_url: '+ detailInfo.pano_image_url}}
          </div>
          <div class="detailtxt">
            {{'floor: '+ detailInfo.floor}}
          </div>
          <div class="detailtxt">
            {{'result_url: '+ detailInfo.result_url}}
          </div>
          <div class="detailtxt">
            {{'task_log: '+ detailInfo.task_log}}
          </div>
          <div class="detailtxt">
            {{'node: '+ detailInfo.node}}
          </div>
        </div>
        <div v-for="item in detailText" :key="item" style="padding:20px">
          <a :href="item" target="_blank" >
            {{ item }}
          </a>
        </div>
      </div>
    </AiDialog>
    <FileUpload
      :post-type = "1"
      :visible="yuyiVisible"
      :item-data="currentEditItem"
      @close="closeFileDialog"
    />
    <TestPlane
      :visible="testPlaneVisible"
      :item-data.sync="currentEditItem"
      @close="closeTestDialog"
    />
  </div>
</template>

<script>
/* eslint-disable */
import moment from 'moment';
import SparkMD5 from 'spark-md5';
import axios from 'axios';

const createSuccess = require('@/assets/views/users/create_success.svg');
const deleteSuccess = require('@/assets/views/users/delete_success.svg');

export default {
  filters: {
    timeFormatter(val) {
      return moment(val).format('YYYY-MM-DD HH:mm:ss');
    }
  },
  data() {
    return {
      vrScene: {
        type: Object,
        default: null
      },
      fileList:[1,2,3,4,5,6],
      activeTab: 'sub-accounts',
      tabs: [{
        name: '我的账户',
        value: 'my-account'
      }, {
        name: '子账户管理',
        value: 'sub-accounts'
      }],
      serchInput:'',
      getvrname:'',
      VRIDinput:'',
      newVRID:'',
      process_node: '',
      group:'',
      floor:'',
      Floorinput:'',
      uploadprogress:0,
      creatVRUIVisible: false,
      bindingUIVisible:false,
      creatARUIVisible:false,
      createSubDialogVisible: false,
      loading: false,
      totalPageCount: 20,
      currentPage: 1,
      allUploaded:0,
      subaccounts: [],
      detailVisible:false,
      testPlaneVisible:false,
      yuyiVisible:false,
      bindTip:'输入后按回车获取名字',
      currentEditItem:null,
      detailText:'',
      detailInfo:'',
      newAccount: {
        userName: '',
        storeName: ''
      },
      editInfo: false
    };
  },
  watch: {
    VRIDinput(val) {
        this.onInput();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    closeTestDialog(){
      this.currentEditItem = null;
      this.testPlaneVisible = false;
    },
    closeFileDialog(){
      this.yuyiVisible = false;
    },
    closedetailDialog(){
     this.detailVisible = false
    },
    showTest(item){
      this.currentEditItem = item;

      this.testPlaneVisible = true;
    },
    showYuyi(item){
      this.currentEditItem = item;
      this.yuyiVisible = true;
    },
    showDetail(item){

      this.detailVisible = true;
      this.detailText = item.videos;
      this.detailInfo = item;

    },
    async onInput(){

      try{
       const { data: { data } } = await this.$http.post(
          '/admin/get-store-info?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          { store_id: this.VRIDinput }
        );
        this.bindTip = data.store_name;
      }
      catch(e){
        console.log('没有找到VRID');
        this.bindTip = '没有找到VRID';
      }

    },
    reDo(item){
      this.currentEditItem = item;
       this.$confirm({
        title: '确认要重跑这组数据吗?',
        message: '改组数据已经生成，重跑会覆盖原有数据!'
      }).then(() => {
         this.sloveData();
      }).catch(() => {});

    },
    ActivityText(item){

      // console.log(item.videos.length);
      if(item.vr_id === null)
      {
        item.editstauts = 0;
        return '绑定VR';
      } else
      {

        if (item.videos.length>=3)
        {
          if(item.status_verbose === 'running'){

              item.editstauts = 3;
              return '停止处理'
          }
          else if( item.status_verbose === 'stopped' || item.status_verbose === 'success' || item.status_verbose === 'error')
          {
              if(item.pivideo_url!=null)
              {
                 item.editstauts = 4;
                 return '重跑数据'
              }

          }

          else if(item.status_verbose === 'ready'){
             item.editstauts = 2;
             return '处理数据'
          }

        }
        // if(item.videos.length<6)
        // {
        //   item.editstauts = 1;
        //   // return '上传数据';
        //   return '';

        // }
        // else
        // {
        //   if(item.status_verbose === 'running'){

        //       item.editstauts = 3;
        //       return '停止处理'
        //   }
        //   else
        //   item.editstauts = 2;
        //   return '处理数据'
        // }

      }
    },
    onFinishUpload(){
      this.allUploaded +=1;
      console.log('上传完一个',this.allUploaded);

    },
    BindVR(item)
    {
       this.currentEditItem = item;
      switch(item.editstauts)
      {
        case  0 :{
          // console.log('绑定VR');
          this.creatARUIVisible = true;
        }
        break
        case  1 :{
            this.allUploaded = 0;
            this.createSubDialogVisible = true;
        }
        break
         case  2 :{
          //  console.log('处理数据');
            this.sloveData();
        }
        break
        case  3 :{
          //  console.log('暂停处理');
            this.putSloveData();
        }
        break
        case  4 :{
          //  console.log('重跑数据');
            this.reDo(item);
        }
        break
      }

    },
    async putSloveData()
    {
      const str = '/admin/ar/pipeline/'+this.currentEditItem.ar_id;
      try {
        const { data: { data } } = await this.$http.put(str);
        setTimeout(()=>
        {
          this.getData();
        },2000);

      }catch(e)
      {

      }
    },
    async sloveData()
    {
      const str = '/admin/ar/pipeline/'+this.currentEditItem.ar_id;
      try {
        const { data: { data } } = await this.$http.post(str);
        setTimeout(()=>
        {
          this.getData();
        },2000);

      }catch(e)
      {

      }
    },
    async clickSearch(){
      let str ="/admin/ar?keyword="+this.serchInput;
      try {
        const { data: { data } } = await this.$http.get(str);
        // const { data: { data } } = await this.$http.post('/admin/list-subaccounts', params);
        console.log('------data--------------------',data);
        if (data) {
          this.subaccounts = data.result;
          this.currentPage = data.pageNum;
          this.totalPageCount = data.pageCount;
        }
      } catch (error) {
        this.$message.basic(error.error_msg);
      }
    },
    createAR(){
      this.creatVRUIVisible=true;
      this.editInfo = false
      this.newVRID = ''
      this.group = ''
      this.floor = ''
    },
    async creatNewAR(){
      this.loading =true;
        const params = { name: 'test' ,vr_id:'aweasdf'};

        const { data } = await this.$http.post('/admin/ar', {});
        console.log(data);
        if (data && data.error_no === 200) {
          console.log();
            this.$message.basic({
              message: '添加成功!',
              icon: createSuccess
            });
            this.loading =false;
            this.getData();
        }

    },
    async addVrId() {
      this.loading =true;
      if(!this.newVRID) {
        this.$message.basic({
          message: '请输入VRID',
        });
        return
      }
      if(!this.group) {
        this.$message.basic({
          message: '请输入group',
        });
        return
      }
      if(!this.floor) {
        this.$message.basic({
          message: '请输入floor',
        });
        return
      }
        let params = { vr_id:this.newVRID,group:this.group,floor:this.floor};
        if(this.process_node) {
          params.process_node = this.process_node
        }
        const { data } = await this.$http.post('/admin/pipeline/generate-imu-pose', params)
        if (data && data.error_no === 200) {
          console.log(8888, data, data.data.ar_id);
            this.$message.basic({
              message: '添加成功!',
              icon: createSuccess
            });
            this.loading =false;
            this.creatVRUIVisible = false
            // 场管理列表的新建数据
            await this.createPlaceMangerData({ar_id: data.data.ar_id});
            this.getData();
        }
    },
    async createPlaceMangerData(params) {
      // 新建数据
      await this.$http.post('/AR/v1/ar-data', params);
    },
    async editItemInfo(item) {
      console.log(item)
      let d = item.floor.split(',')
      this.ar_name = item.name
      this.group = d[0]
      this.floor = d[1]
      this.creatVRUIVisible = true
      this.editInfo = true
      this.newVRID = item.vr_id
      this.ar_id = item.ar_id
      this.pk_id = item.id; // 修改
    },
    async toedit() {
      if(!this.group) {
        this.$message.basic({
          message: '请输入group',
        });
        return
      }
      if(!this.floor) {
        this.$message.basic({
          message: '请输入floor',
        });
        return
      }
      let target = {
        vr_id: this.newVRID,
        group: this.group,
        floor: this.floor
      }
      const { data: { data } } = await this.$http.patch(
          `/admin/ar/${this.ar_id}`,
          target
        );
      console.log(data)
      this.creatVRUIVisible = false
      this.editInfo = false
      await this.modifyGroupInfo();
      this.clickSearch()
    },
    async modifyGroupInfo() {
      await this.$http.post(`/AR/v1/ar-data/${this.pk_id}`);
    },
    closeBindingDialog(){
      this.bindingUIVisible  =false;
    },
    async clickAddVideo(){
      // this.bindingUIVisible = true;
      this.$refs.uploader.click();
    },
    getVideoFile() {
      console.log('来了啊 啊 啊');
      this.bindingUIVisible = true;
      return;
        var file = this.$refs.uploader.files[0];
        const fileSize = file.size; // 文件大小
        const chunkSize = 1024 * 1024 * 10; // 切片的大小
        const chunks = Math.ceil(fileSize / chunkSize); // 获取切片个数
        const fileReader = new FileReader();
        const spark = new SparkMD5.ArrayBuffer();
        const bolbSlice =
            File.prototype.slice ||
            File.prototype.mozSlice ||
            File.prototype.webkitSlice;
        let currentChunk = 0;

        fileReader.onload = e => {
            const res = e.target.result;

            spark.append(res);
            currentChunk++;
            if (currentChunk < chunks) {
                loadNext();
                console.log(`第${currentChunk}分片解析完成, 开始第${currentChunk +1}分片解析`);
            } else {
                const md5 = spark.end();
                console.log('解析完成');
                this.upload(md5,file,file.name.split('.')[0]);
            }
        };

        const loadNext = () => {
            const start = currentChunk * chunkSize;
            const end =
                start + chunkSize > file.size ? file.size : start + chunkSize;
            fileReader.readAsArrayBuffer(bolbSlice.call(file, start, end));
        };
        loadNext();
    },

    upload(md5,file,filename) {
      this.$refs.uploader.value = null;
      console.log(md5)
      this.bindingUIVisible = true;
      return;
      return new Promise((resolve, reject) => {
        this.$http
          .post(
            "https://vrapi.aibee.cn/video/upload11?md5=" + md5,
            file,
            { headers: { "Content-Type": "text/plain" } ,
               onUploadProgress: progressEvent => {
                let complete = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%'
                this.uploadprogress = (progressEvent.loaded / progressEvent.total * 100 | 0);
                console.log('上传 ' + complete);
              }
            })
          .then(async response => {
           console.log('上传完成：');
           console.log(response.data.data);
          //  console.log(response.data.data[0].filename,'this.uploadType: ',this.uploadType);
           //console.log(response.data.data[0].md5);
            resolve(response.data);
          })
          .catch(error => {
            console.log('错误错误！！！',error);
            reject(error);
          });
      });
    },
    switchTo(tabValue) {
      this.activeTab = tabValue;
    },
    showConfirm(item) {
      this.currentEditItem = item;
      this.$confirm({
        title: '确认要删除这组数据吗?',
        message: '删除将会终止正在进行的处理工作，且无法恢复!'
      }).then(async () => {
        await this.deletePlaceGroupId(item);
        this.deleteSubAccount();
      }).catch(() => {});
    },
    async deletePlaceGroupId(item) {
      await this.$http.delete(`/AR/v1/ar-data?ar_id=${item.ar_id}`);
    },
    async getData() {

      let str ="/admin/ar?page="+ this.currentPage+'&page_size=10';
      try {
        const { data: { data } } = await this.$http.get(str);
        // const { data: { data } } = await this.$http.post('/admin/list-subaccounts', params);
        console.log('------data--------------------',data);
        if (data) {
          this.subaccounts = data.result;
          this.currentPage = data.pageNum;
          this.totalPageCount = data.pageCount;
        }
      } catch (error) {
        this.$message.basic(error.error_msg);
      }
    },
    closeDialog() {

      this.createSubDialogVisible = false;
      this.creatARUIVisible = false;
    },
    async bindVRID()
    {
      this.loading =true;
      if(this.bindTip==='输入后按回车获取名字'||(this.bindTip==='没有找到VRID')){
        this.$message.basic({
              message: '请输入正确VRID!'
            });
        return;
      }
        // const params = { name: this.bindTip ,vr_id:this.VRIDinput};
        const params = {vr_id:this.VRIDinput,floor:this.Floorinput};
        let qstr = "/admin/ar/"+this.currentEditItem.ar_id;
        const { data } = await this.$http.patch(qstr, params);
        console.log('-----------------------:',data);
          if (data && data.error_no === 200) {
                    console.log();
              this.$message.basic({
                message: '绑定成功!',
                icon: createSuccess
              });
              this.loading =false;
              this.creatARUIVisible = false;
              this.getData();
          }
        else{
          this.$message.basic('VRID 不存在');
        }
    },
    clearDialogInputs() {
      this.getData();
    },
    async createNewSubAccount() {
      this.loading = true;
      const params = {
        username: this.newAccount.userName,
        store_name: this.newAccount.storeName
      };

      try {
        const { data } = await this.$http.post('/admin/add-subaccount', params);
        if (data && data.error_no === 200) {
          this.$message.basic({
            message: '添加成功!',
            icon: createSuccess
          });
          this.loading = false;
          this.closeDialog();
          this.getData();
        }
      } catch (error) {
        // error
      }
    },
    async deleteSubAccount(id) {
        let qstr = "/admin/ar/"+this.currentEditItem.ar_id;
        const { data } = await this.$http.delete(qstr);
        if (data && data.error_no === 200) {
            this.$message.basic({
              message: '删除成功!',
              icon: createSuccess
            });
            this.getData();
        }
    }
  }
};
</script>

<style lang="scss" scoped>
.tabs {
  width: 100%;
  margin: 10px 0;
  justify-content: space-between;
}

.actions {
  margin: 0 40px;
  width: 0px;

  &__right {
    margin-right: 40px;
  }

  &__left-tilte {
    margin-left: 40px;
    font-family:"微软雅黑";
    font-size: 24px;
    color: #888;
  }

  &__add-btn {
    width: 89px;
    height: 22px;
    font-size: 11px;
    margin-left: 12px;

    .material-icons {
      margin-right: 0;
      font-size: 14px;
    }
  }

  &__search-input {
    width: 183px;
    height: 22px;
  }

  &__search-btn {
    width: 22px;
    height: 22px;

    .material-icons {
      margin: 0;
      font-size: 14px;
      color: #9e9e9e;
    }
  }
}

.table-wrapper {
  margin: 0 40px;
}

.table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 8px;

  tr {
    height: 50px;
  }

  th {
    border: 0;
    font-size: 14px;
    color: #888;
  }

  thead {
    th {
      background-color: #ddeffb;

      &:first-child {
        border-top-left-radius: 4px;
      }

      &:last-child {
        border-top-right-radius: 4px;
      }
    }
  }

  tbody {
    td {
      background-color: white;
      border-bottom: 1px solid #eee;
    }

    tr:last-child td {
      border-bottom: 0;
    }

    tr:last-child td:first-child {
      border-bottom-left-radius: 4px;
    }

    tr:last-child td:last-child {
      border-bottom-right-radius: 4px;
    }
  }

  td {
    text-align: center;
    color: #888;
    font-size: 14px;
  }
}

.videodiv
{
  display:inline-block;
  width: 33.33%;
  // float: left;
}

.pagination {
  width: 100%;
  margin: 38px 0;
}

.create-sub-dialog {
  &__header {
    height: 50px;
    display: flex;
    align-items: center;
    margin-left: 20px;
    font-weight: 500;
    color: #6c6c6c;
  }

  &__creatARcontent{
    width: 100%;
    height: 100%;
    padding: 20px 0;
    flex-direction: column;

  }

  &__content {
    width: 100%;
    height: 450px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
  }

  &__footer {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;

    .ai-button {
      width: 59px;
      height: 26px;
      margin: 0 10px;
      font-size: 14px;
    }
  }
}

.videoname{

  color: #888;
}

.progress-dialog {
  &__header {
    height: 50px;
    display: flex;
    align-items: center;
    margin-left: 20px;
    font-weight: 500;
    color: #6c6c6c;
  }


  &__content {
    display: block;
    padding: 20px 16px;
  }

  &__loadingdiv{
    padding: 20px;
  }
}

.el-col-8 {
    max-width: 330px;
    // min-width: 330px;
    width: calc(33.3%);
}

.form-item {
  margin-bottom: 20px;
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }

  &__label {
    display: inline-block;
    width: 80px;
    text-align: right;
    color: #6c6c6c;
    font-size: 14px;
  }

  &__content {
    display: inline-block;
    margin-left: 12px;

    .ai-input-wrapper {
      width: 240px;
      height: 28px;
    }
  }

    .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
}

.detailtxt{
  margin-left: 10px;
  margin-top: 15px;
}
</style>
